import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * useNotifyMe custom hook
 */
export default function useNotifyMe() {
	const {managerRepository} = useGeneralProvider();

	return {
		createNotifyMe: (email: string, productId: string) => {
			// Read when called: the locale can change after the render.
			const currentLocale = managerRepository.getLocalesMgr().getCurrentLocale();

			return managerRepository.getCommerceApi().customShopperNotifyMe.createNotifyMe({
				body: {
					email,
					productId,
					countryCode: currentLocale.getCountryCode(),
					languageCode: currentLocale.getLanguageCode()
				}
			});
		}
	};
}
